import { useState } from "react";
import {Typography,  Button, InputAdornment, Container, TextField, Select, MenuItem } from "@mui/material";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const AddMilkExpense = ({ addExpense }) => {
    const [date, setDate] = useState(dayjs());
    const [time, setTime] = useState(dayjs());
    const [quantity, setQuantity] = useState("");
    const [unit, setUnit] = useState("Litre"); // Default unit
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        addExpense({
            date: date.format("YYYY-MM-DD"),
            time: time.format("HH:mm"),
            quantity: parseFloat(quantity),
            unit, // Store selected unit (Litre or Millilitre)
        });
        navigate("/"); // Redirect to list page
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Container sx={{ marginTop: 6 }}>
            <Typography variant="h5" sx={{ color: "#0d0127", textAlign: "left", marginBottom: 2 }}>
                MEM - Milk Expense Manager
            </Typography>
                <form onSubmit={handleSubmit}>
                    {/* Date Picker */}
                    <DatePicker
                        label="Select Date"
                        value={date}
                        onChange={(newValue) => setDate(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                    />

                    {/* Time Picker */}
                    <TimePicker
                        label="Select Time"
                        value={time}
                        onChange={(newValue) => setTime(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                    />

                    {/* Quantity Input with Dropdown */}
                    <TextField
                        label="Quantity"
                        type="number"
                        fullWidth
                        margin="normal"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Select
                                        value={unit}
                                        onChange={(e) => setUnit(e.target.value)}
                                        sx={{ backgroundColor: "white", padding: "0 5px", fontSize: "14px" }}
                                    >
                                        <MenuItem value="Litre">Litre</MenuItem>
                                        <MenuItem value="Millilitre">Millilitre</MenuItem>
                                    </Select>
                                </InputAdornment>
                            ),
                        }}
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                    />

                    {/* Submit Button */}
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                        Add Expense
                    </Button>
                </form>
            </Container>
        </LocalizationProvider>
    );
};

export default AddMilkExpense;
